'use client'

import { QueryClientProvider as BaseQueryClientProvider } from '@tanstack/react-query'
import { IntegrationActivationProvider } from '@/features/gdpr/integration-activation-context'
import { getQueryClient } from '@/setup/query-cache'
import { IChildrenProps } from '@/typings/children-props'

export default function QueryClientProvider({ children }: IChildrenProps) {
    // NOTE: Avoid useState when initializing the query client if you don't
    //       have a suspense boundary between this and the code that may
    //       suspend because React will throw away the client on the initial
    //       render if it suspends and there is no boundary
    const queryClient = getQueryClient()

    return (
        <BaseQueryClientProvider client={queryClient}>
            <IntegrationActivationProvider>{children}</IntegrationActivationProvider>
        </BaseQueryClientProvider>
    )
}
